export const SELECTION_CHECKBOX_CLASS = 'd-responsive-table--selection-checkbox';
export const TableEvents = {
  /**
   * Dispatched after the table was refreshed.
   *
   * @event ResponsiveTable#refresh
   */
  REFRESH: 'refresh',

  /**
   * Dispatched after one or multiple rows have been selected or de-selected.
   *
   * @event ResponsiveTable#select
   */
  SELECT: 'select',
} as const;
export const ACTIONS_COLUMN_KEY = 'RT_ACTION_COLUMN';
